var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('div',{staticClass:"logout-wrapper"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.onLogout()}}},[_c('icon',{staticClass:"logout-icon",attrs:{"icon":"power-off"}}),_vm._v(" "+_vm._s(_vm.$t('header.logout')))],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }